import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-full xl:h-screen w-full pt-6 xl:pt-[88px] flex flex-col" }
const _hoisted_2 = { class: "w-full max-md:h-full md:flex-1 md:overflow-y-auto no-scrollbar py-6 px-4 md:px-[20px] flex flex-col md:items-center gap-6" }
const _hoisted_3 = { class: "grid grid-cols-2 md:grid-cols-[auto_auto_1fr_1fr] gap-6 md:w-full md:max-w-[1161px]" }
const _hoisted_4 = { class: "col-span-2 flex gap-[12px] md:gap-6" }

import { onMounted, ref, watchEffect } from "vue";
import { fetchChineseCalendarMonth } from "@/api/calculators";
import { ChineseCalendarDate } from "@/types/calculators";
import { formatLocalDate } from "@/utils/date";
import {
  CHINESE_CALENDAR_SUPPORTED_YEARS,
  MONTHS_KEYS,
} from "@/constants/chineseCalendar";
import { useI18n } from "vue-i18n";
import AppSelect from "@/components/inputs/AppSelect.vue";
import MobileCalendar from "@/views/Calculators/ChineseCalendar/components/MobileCalendar.vue";
import DescktopCalendar from "@/views/Calculators/ChineseCalendar/components/DescktopCalendar.vue";
import PageTitleWithBackButton from "@/components/PageTitleWithBackButton.vue";
import CheckBox from "@/components/inputs/CheckBox.vue";
import PrintButton from "@/components/buttons/PrintButton.vue";


export default /*@__PURE__*/_defineComponent({
  ...{
  name: "ChineseCalendarView",
},
  __name: 'ChineseCalendarView',
  setup(__props) {

const currentYear = ref<number | null>(null);
const currentMonth = ref<number | null>(null);
const chineseYear = ref(0);
const chineseMonth = ref(0);
const chineseCalendar = ref<ChineseCalendarDate[]>([]);
const showAsIcons = ref<boolean>(false);
const waitApiCall = ref<boolean>(false);

const desktopCalendarRef = ref();

const { t } = useI18n();



onMounted(() => {
  const now = new Date();
  currentYear.value = now.getFullYear();
  currentMonth.value = now.getMonth();
});

watchEffect(async () => {
  if (currentYear.value === null || currentMonth.value === null) {
    return;
  }
  chineseCalendar.value = [];
  await getChineseCalendar();
});

async function getChineseCalendar() {
  waitApiCall.value = true;
  if (currentYear.value === null || currentMonth.value === null) {
    return;
  }
  try {
    chineseCalendar.value = await fetchChineseCalendarMonth(
      formatLocalDate(new Date(currentYear.value, currentMonth.value, 1)),
      formatLocalDate(new Date(currentYear.value, currentMonth.value + 1, 0))
    );
    chineseYear.value = currentYear.value;
    chineseMonth.value = currentMonth.value;
  } finally {
    waitApiCall.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(PageTitleWithBackButton, {
        "page-title": _unref(t)('calculators.chinese-calendar.title'),
        "title-align": 'left',
        class: "md:w-full md:max-w-[1161px] xl:!flex !mb-0"
      }, null, 8, ["page-title"]),
      (chineseCalendar.value)
        ? (_openBlock(), _createBlock(MobileCalendar, {
            key: 0,
            class: "md:hidden",
            "chinese-calendar": chineseCalendar.value,
            month: chineseMonth.value,
            year: chineseYear.value,
            "month-key": _unref(MONTHS_KEYS)[chineseMonth.value]
          }, null, 8, ["chinese-calendar", "month", "year", "month-key"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(AppSelect, {
          class: "md:w-[132px]",
          items: _unref(CHINESE_CALENDAR_SUPPORTED_YEARS),
          "default-value": currentYear.value,
          onSelectOption: _cache[0] || (_cache[0] = (selectedYear) => currentYear.value = Number(selectedYear))
        }, null, 8, ["items", "default-value"]),
        _createVNode(AppSelect, {
          class: "md:w-[164px]",
          items: _unref(MONTHS_KEYS),
          "default-value": _unref(MONTHS_KEYS)[currentMonth.value],
          onSelectOption: _cache[1] || (_cache[1] = (selectedMonth) => currentMonth.value = _unref(MONTHS_KEYS).indexOf(selectedMonth))
        }, {
          option: _withCtx(({ item }) => [
            _createTextVNode(_toDisplayString(_unref(t)(`months.${item}`)), 1)
          ]),
          _: 1
        }, 8, ["items", "default-value"]),
        _createElementVNode("div", _hoisted_4, [
          false
            ? (_openBlock(), _createBlock(PrintButton, {
                key: 0,
                "btn-classes": "size-11",
                "icon-classes": "mx-auto",
                onClick: _ctx.handlePrint
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true),
          _createVNode(CheckBox, {
            "input-id": "show-icons",
            label: "Показывать иконками",
            onToggle: _cache[2] || (_cache[2] = ($event: any) => (showAsIcons.value = !showAsIcons.value)),
            class: "select-none"
          })
        ])
      ]),
      (chineseCalendar.value)
        ? (_openBlock(), _createBlock(DescktopCalendar, {
            key: 1,
            ref_key: "desktopCalendarRef",
            ref: desktopCalendarRef,
            class: "max-md:hidden",
            "chinese-calendar": chineseCalendar.value,
            month: chineseMonth.value,
            year: chineseYear.value,
            "month-key": _unref(MONTHS_KEYS)[chineseMonth.value],
            showAsIcons: showAsIcons.value
          }, null, 8, ["chinese-calendar", "month", "year", "month-key", "showAsIcons"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})